import './TransparentHeader.less';
import React from 'react';
import { HOME } from '@/routing/routes';
import { navigate } from '@/routing';

function TransparentHeader() {
    return (
        <div className="transparent-header" onClick={() => navigate(HOME)}>
            <CloseIcon />
        </div>
    );
}

const CloseIcon = () => (
    <svg className="icon icon-close" viewBox="0 0 16 16">
        <path
            d="M1.196.147L1.28.22 8 6.939l6.72-6.72c.293-.292.768-.292 1.06 0 .267.267.291.684.073.977l-.072.084L9.06 8l6.72 6.72c.292.293.292.768 0 1.06-.267.267-.683.29-.977.073l-.084-.073L8 9.061l-6.72 6.72c-.293.292-.767.292-1.06 0-.267-.267-.29-.683-.073-.977l.073-.084L6.939 8 .219 1.28C-.072.987-.072.513.22.22c.267-.267.684-.29.977-.073z"
            transform="translate(-322 -38) translate(322 38)"
        />
    </svg>
);

export default TransparentHeader;
